// 模块编号与服务端 jx_coupon_business_module.code 保持一致。
const BUSINESS_MODULE = Object.freeze({
    PHOTOGRAPHY: Object.freeze({ code: 1, description: '摄影服务' }),
});
module.exports = BUSINESS_MODULE;
